import _ from "lodash";
import * as z from "../../../framework";

export const fieldVisibilitySettings: any[] = [];

export function loadCompanyFieldVisibility() {
    var deferred = $.Deferred();

    if (localStorage.fieldVisibilitySettings) {
        _.assign(fieldVisibilitySettings, $.parseJSON(z.getLocalStorage("fieldVisibilitySettings")));

        deferred.resolve();
    } else {
        z.ajax({
            cache: true,
            type: "GET",
            url: "FieldVisibilitySettings?$top=10000&$filter=Platform eq 'B' or Platform eq 'W'"
        }).done(function (data, status) {
            var results = data.d.results;

            _.assign(fieldVisibilitySettings, results);

            deferred.resolve();

            try {
                z.setLocalStorage("fieldVisibilitySettings", JSON.stringify(fieldVisibilitySettings));
            } catch (e) {
                console.log(`error caching field visibility settings: ${e}`);
            }
        }).fail(function (e) {
            deferred.reject(e);
        });
    }

    return deferred.promise();
}
